import React, { Component } from 'react';
import { appStore } from '../../stores/AppStore';
import { getTitleEmailUrl, projectTitle, addUserToWip, mailFinder } from "../../stores/APIEndpoints";
import { Select, Typography, Form, Button, Spin, message } from 'antd';
import { toUrlParams } from "../../stores/Util";

const { Text } = Typography;
const { Option } = Select;

export class AddUserToWip extends Component {


    constructor(props) {
        super(props);
        this.apiProxy = appStore.apiProxy;
        this.state = {
            titleId: undefined,
            role: undefined,
            emails: undefined,
            names: undefined,
            loading: false,
            titleList: '',
            email: " ",
            projectTitles: []
        };

    }
    async componentDidMount() {
        this.populatetitle();
    }
    populatetitle = async () => {
        let response = await this.apiProxy.getAsync(projectTitle);
        const option = await response.json();
        this.setFiltereditOptions(0, option.map(t => ({
            name: t.shortTitle,
            label: t.shortTitle,
            value: t.id
        })));
    }
    setFiltereditOptions = (index, options) => {
        this.setState({ "projectTitles": options });
    };

    render() {
        const { projectTitles } = this.state;
        const titles = [];
        for (let i = 0; i < projectTitles.length; i++) {

            titles.push(<Option value={projectTitles[i].name}>{projectTitles[i].name}</Option>)
        }

        const { getFieldDecorator } = this.props.form;
        const config = {
            rules: [{ type: 'object', required: true, message: 'Please select time!' }],
        };


        return (
            <div style={styles.root}>

                <Spin spinning={this.state.loading}>
                    <div style={styles.section}>
                        <div style={styles.selectItem}>
                            <Text>Select Title</Text>
                            <Select value={this.state.titleId} onChange={this.handleTitleChange} placeholder={'Title'}>
                                {titles}
                            </Select>
                        </div>

                        <div style={styles.selectItem}>
                            <Text>Select Actor</Text>
                            <Select value={this.state.role} onChange={this.handleActorChange} placeholder={'Actor'}>
                                <Option value="70">Editor</Option>
                                <Option value="72">CM</Option>
                            </Select>
                        </div>

                        <div style={styles.selectItem}>
                            <Text name="UserEmail">User Email</Text>
                            {getFieldDecorator('UserEmail', {
                                rules: [{ required: true, message: 'Please input your E-mail!' }]
                            })(
                                <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder="Useremail"
                                    onSearch={this.validationText}
                                    onChange={this.handleChange}

                                >
                                    {this.state.children}
                                </Select>,
                            )}
                        </div>
                    </div>
                    <div style={{ ...styles.section, flexDirection: 'column' }}>
                        <Button type="primary" style={{ alignSelf: 'flex-end' }} onClick={this.handleSubmit}>
                            Update
                        </Button>
                    </div>
                </Spin>
            </div>
        );
    }

    handleChange = (value) => {
        this.setState({ children: [] });

    }
    validationText = async (value) => {

        if (value.match(/@/g)) {
            const params = {
                email: value
            };
            const url = mailFinder + '?' + toUrlParams(params);
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();
            this.setState({ email: data[0].name });
            const childrenData = [];
            if (data.length != 0) {
                for (let i = 0; i < data.length; i++) {
                    childrenData.push(<Option key={data[i].name}>{data[i].name}</Option>);
                }
            }
            else {
                message.error('Please register new user.');
            }

            this.setState({ children: childrenData });


        }
        else {
            //	alert("false");
        }
    }

    handleTitleChange = (value) => {
        this.setState({ titleId: value });
        this.getActorInfoFor(value, this.state.role);
    };

    handleActorChange = (value) => {
        this.setState({ role: value });
    };

    getActorInfoFor = async (titleId, role) => {
        if (!titleId || !role) {
            return;
        }

        this.setState({ loading: true });
        try {
            const params = { titleId, role };
            const response = await this.apiProxy.asyncPost(getTitleEmailUrl, params);
            let data = await response.json();
            this.setState({ emails: data.emails, names: data.names });
        } catch (e) {
        }
        this.setState({ loading: false });
    };

    handleSubmit = async (values) => {
        this.setState({ loading: true });
        try {
            const bodyParams = { "abbreviation": this.state.titleId, "email": this.state.email, "reviewer_role_id": this.state.role }
            const response = await this.apiProxy.asyncPost(addUserToWip, bodyParams);
            message.success('Updated successfully');
        } catch (e) {
            message.error('Unable to update details');
        }
        this.setState({ loading: false });
    }
}

const styles = {
    root: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
    },
    selectItem: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        padding: '0px 10px',
    },
    section: {
        display: 'flex',
        flex: 1,
        fledDirection: 'row',
        padding: '10px 0px'
    }
};
export default Form.create({ name: 'normal_login' })(AddUserToWip);